import React from 'react'

export const SiteLinksLayout = ({ children }) => {
  return <div className="site-links">{children}</div>
}
